import { AnimationOptions, AnimationScreenParams, AnimationScreenPayload } from "types/animationScreen";
import { create } from "zustand";

type AnimationScreenState = {
    show: (id: string, payload?: AnimationScreenParams) => Promise<void>;
    hide: (id: string) => void;
    stop: (id: string) => void;
    animations: Record<string, AnimationScreenPayload>;
    resolves: Record<string, (value: void) => void>;
};

const defaultAnimationScreenOptions: AnimationOptions = {
  duration: 1000,
  loop: false,
  touchable: true,
};

const useAnimationScreenStore = create<AnimationScreenState>((set, get) => ({
    show: (id, payload) => {
        return new Promise((resolve) => {
            const options = { ...defaultAnimationScreenOptions, ...payload?.options };
            const params: AnimationScreenParams = { id, status: 'processing' };
            set({ animations: { ...get().animations, [id]: { ...payload, ...params, options, data: payload?.data ?? {} } }, resolves: { ...get().resolves, [id]: resolve } });
        });
    },
    stop: (id: string) => {
        set({ animations: { ...get().animations, [id]: { ...get().animations[id], status: 'stopped' } } });
    },
    hide: (id: string) => {
        const resolve = get().resolves[id];
        const remainingResolves = { ...get().resolves };

        resolve?.();
        set({ animations: { ...get().animations, [id]: { ...get().animations[id], status: 'idle' } }, resolves: remainingResolves });
    },
    animations: {},
    resolves: {},
}));

export default useAnimationScreenStore;